import { getFormValues } from 'redux-form';
import { createSelector } from 'reselect';

import { filterByString } from '@topconagriculture/frontend-utils';

import { SharingPartner } from '../../../core/api/sharing/sharing.types';
import { Forms } from '../../form/form.selector';
import { RootState } from '../../reducers';

export const getPartners = (state: RootState): SharingPartner[] => state.entities.sharing.partners;

export const getFilteredPartners = createSelector(
  [getPartners, getFormValues(Forms.searchPartner)],
  (partners, formValues: any): SharingPartner[] =>
    formValues
      ? partners.filter((partner) =>
          filterByString(partner.mail || partner.name || undefined, formValues.searchPartner),
        )
      : partners,
);
